module.exports = __webpack_public_path__ + "static/img/logo.bbd8755a.png";